import ProgressBar from '@ramonak/react-progress-bar';
import { useState } from 'react';

import { useAuthContext } from '@/components/Providers/AuthProvider';
import Button from '@/components/V2/Button';
import cn from '@/helpers/utils/classNames';
import { MAGDetails } from '@/types/Reports';

import VolumeBucketModels from '../Reports/VolumeBucketModals/VolumeBucketModels';

function pawClubProgressArray(total: number, parts: number): number[] {
  return Array.from({ length: parts }, (_, i) => total * ((i + 1) / parts));
}
type PawClubProps = {
  customerId?: number;
  pawClubMembers?: MAGDetails['pawClubMembers'];
  shouldHandleVolumeBucket?: boolean;
  onNewPCMembersClick?: () => void;
  onTotalPCMembersClick?: () => void;
  onPawPointsEarnedClick?: () => void;
  isDashboard?: boolean;
};

const PawClub = ({
  customerId,
  pawClubMembers = {} as MAGDetails['pawClubMembers'],
  shouldHandleVolumeBucket = false,
  onNewPCMembersClick,
  onPawPointsEarnedClick,
  onTotalPCMembersClick,
  isDashboard,
}: PawClubProps) => {
  const [volumeBucket1Show, setVolumeBucket1Show] = useState(false);
  const [volumeBucketLabel, setVolumeBucketLabel] = useState('');
  const [isTableView, setIsTableView] = useState(false);
  const [volumeBucket, setVolumeBucket] = useState<number>();
  const { customer } = useAuthContext();
  const safeNumber = (value: any) => (value === undefined ? 0 : parseFloat(value));

  const pawClubProgressChunks = pawClubProgressArray(100, 7);
  const pawClubProgressValue = +(pawClubMembers.completePercentInBar || '0');

  const pawClubProgressChunksRenderable = pawClubProgressChunks.map((chunk, idx) => {
    const chunks = pawClubProgressChunks;
    if (pawClubProgressValue >= chunk) return 100;
    if (pawClubProgressValue < chunk && pawClubProgressValue > chunk - chunks[0]) {
      return ((pawClubProgressValue - (chunk - chunks[0])) / chunks[0]) * 100;
    }
    return 0;
  });

  const BOTextStyling = isDashboard
    ? 'v2-text-[#333333] v2-text-sm v2-font-sweet-sans-pro v2-font-normal v2-text-center v2-mb-[8px] v2-max-w-[150px] v2-w-full v2-mx-auto'
    : 'v2-text-[#333333] v2-text-base v2-font-sweet-sans-pro v2-font-normal v2-text-center v2-mb-[8px] v2-max-w-[150px] v2-w-full v2-mx-auto';
  return (
    <>
      <div className="v2-border-t v2-border-[#EAECF0] v2-pt-[8px] v2-flex v2-flex-col v2-gap-[20px]">
        <div className="v2-flex v2-flex-col">
          <div className="v2-flex v2-items-center v2-relative v2-pb-[26px]">
            {pawClubProgressChunksRenderable.map((p, idx) => (
              <ProgressBar
                key={`pawclub-progress-${idx}-${p}`}
                completed={p}
                isLabelVisible={false}
                className={cn(
                  'v2-w-full v2-relative !v2-rounded-xs [&>div]:!v2-rounded-xs [&>div]:!v2-h-[26px] [&>div>div]:!v2-h-[26px]',
                  { 'v2-max-w-[57px]': idx == 0 || idx == pawClubProgressChunksRenderable.length - 1 }
                )}
                bgColor={'#154734'}
                baseBgColor={'#F2F4F7'}
              />
            ))}

            <div className="v2-absolute v2-flex v2-items-center v2-w-full v2-top-0 v2-left-0">
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-max-w-[57px] v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-4px] v2-bottom-[-18px]">
                  5
                </p>
              </div>
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  10
                </p>
              </div>
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  15
                </p>
              </div>
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  20
                </p>
              </div>
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  25
                </p>
              </div>
              <div className="v2-border-r v2-border-[#999999] v2-w-full v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  30
                </p>
              </div>
              <div className="v2-border-0 v2-border-[#999999] v2-w-full v2-max-w-[57px] v2-p-[4px] v2-pt-[42px] v2-relative">
                <p className="v2-text-center v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#101828] v2-text-xs v2-absolute v2-right-[-7px] v2-bottom-[-18px]">
                  &nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="v2-p-[16px] v2-flex v2-flex-col v2-gap-[8px] v2-bg-[#F9F9F9] v2-rounded-xs">
          <div className="v2-flex v2-items-center v2-justify-between">
            <p className="v2-text-[#333333] v2-text-base v2-font-sweet-sans-pro-semi-bold v2-font-semibold">
              New Paw Club Members This Month
            </p>
          </div>
          <p
            className={cn('v2-text-[#333333] v2-text-base v2-font-sweet-sans-pro v2-font-normal', {
              '!v2-text-xs': isDashboard,
            })}
          >
            For each 5 new Paw Club members you receive 600 paw points.
          </p>
        </div>
        <div className="v2-grid v2-grid-cols-3 v2-gap-[12px]">
          <div className="v2-flex v2-flex-col v2-justify-between">
            <p className={BOTextStyling}>New Paw Club Members</p>
            <div className="v2-p-[16px] v2-flex v2-items-center v2-justify-center v2-bg-[#F5F7F2] v2-rounded-xs v2-h-[100px]">
              <Button
                btnSize="lg"
                scheme="text"
                type="button"
                variant="outlined"
                className="!v2-p-0 !v2-bg-transparent v2-font-sweet-sans-pro-medium v2-font-medium !v2-text-[32px] v2-text-primary v2-leading-[43px] v2-w-full v2-flex v2-items-center v2-justify-center v2-underline"
              >
                {safeNumber(pawClubMembers.newPawClubMembers) > 0 ? (
                  <span
                    className="v2-underline v2-cursor-pointer"
                    onClick={() => {
                      if (onNewPCMembersClick) onNewPCMembersClick();
                      if (shouldHandleVolumeBucket) {
                        setVolumeBucketLabel('New Paw Club Members');
                        setIsTableView(false);
                        setVolumeBucket(12);
                        setVolumeBucket1Show(true);
                      }
                    }}
                  >
                    {pawClubMembers.newPawClubMembers}
                  </span>
                ) : (
                  <span>{pawClubMembers.newPawClubMembers}</span>
                )}
              </Button>
            </div>
          </div>
          <div className="v2-flex v2-flex-col v2-justify-between">
            <p className={BOTextStyling}>Total Paw Club Members</p>
            <div className="v2-p-[16px] v2-flex v2-items-center v2-justify-center v2-bg-[#F5F7F2] v2-rounded-xs v2-h-[100px]">
              <Button
                btnSize="lg"
                scheme="text"
                type="button"
                variant="outlined"
                className="!v2-p-0 !v2-bg-transparent v2-font-sweet-sans-pro-medium v2-font-medium !v2-text-[32px] v2-text-primary v2-leading-[43px] v2-w-full v2-flex v2-items-center v2-justify-center v2-underline"
              >
                {safeNumber(pawClubMembers.totalPawClubMembers) > 0 ? (
                  <span
                    className="v2-underline v2-cursor-pointer"
                    onClick={() => {
                      if (onTotalPCMembersClick) onTotalPCMembersClick();
                      if (shouldHandleVolumeBucket) {
                        setVolumeBucketLabel('Total Paw Club Members');
                        setIsTableView(false);
                        setVolumeBucket(22);
                        setVolumeBucket1Show(true);
                      }
                    }}
                  >
                    {pawClubMembers.totalPawClubMembers}
                  </span>
                ) : (
                  <span>{pawClubMembers.totalPawClubMembers}</span>
                )}
              </Button>
            </div>
          </div>
          <div className="v2-flex v2-flex-col v2-justify-between">
            <p className={BOTextStyling}>PawPoints Earned This Month</p>
            <div className="v2-p-[16px] v2-flex v2-items-center v2-justify-center v2-bg-[#F5F7F2] v2-rounded-xs v2-h-[100px]">
              <Button
                btnSize="lg"
                scheme="text"
                type="button"
                variant="outlined"
                className="!v2-p-0 !v2-bg-transparent v2-font-sweet-sans-pro-medium v2-font-medium !v2-text-[32px] v2-text-primary v2-leading-[43px] v2-w-full v2-flex v2-items-center v2-justify-center"
                onClick={() => onPawPointsEarnedClick && onPawPointsEarnedClick()}
              >
                {pawClubMembers.sampleCreditsEarnedThisMonth}
              </Button>
            </div>
          </div>
        </div>
        <div className="v2-p-[16px] v2-flex v2-flex-col v2-gap-[8px] v2-bg-[#F9F9F9] v2-rounded-xs">
          <div className="v2-flex v2-items-center v2-justify-between">
            <p className="v2-text-[#333333] v2-text-base v2-font-sweet-sans-pro v2-font-normal">Paw Club Qualified:</p>
            <p className="v2-text-primary v2-text-base v2-font-sweet-sans-pro v2-font-normal">
              {pawClubMembers.isPawClubQualified ? 'Yes' : 'No'}
            </p>
          </div>
        </div>
      </div>

      {shouldHandleVolumeBucket && (
        <VolumeBucketModels
          modalOpen={volumeBucket1Show}
          setModalOpen={setVolumeBucket1Show}
          customerId={customerId || customer?.customerID}
          volumeBucket={volumeBucket}
          selectedPeriodid={undefined}
          volumeBucketLabel={volumeBucketLabel}
          isTableView={isTableView}
        />
      )}
    </>
  );
};

export default PawClub;
